'use client';

import { ErrorBoundary } from '@benzinga/core-ui';
import { NavigationFooter } from '@benzinga/navigation-ui';
import { FreestarPrivacyManager } from '@benzinga/ads';
import React from 'react';
import type { PageConfig } from '../page/pageConfig';

interface RootFooterProps {
  pageProps?: PageConfig;
}
const RootFooter = ({ pageProps }: RootFooterProps) => {
  return (
    <>
      {!pageProps?.headerProps?.hideFooter && (
        <ErrorBoundary name="footer">
          <NavigationFooter
            afterCopyrightBar={<FreestarPrivacyManager />}
            copyrightLinks={pageProps?.headerProps?.copyrightLinks}
            logoVariant={pageProps?.headerProps?.logoVariant}
            menu={pageProps?.headerProps?.footerMenu}
            showStickyFooter={pageProps?.headerProps?.showStickyFooter}
            variant={pageProps?.headerProps?.footerVariant}
          />
        </ErrorBoundary>
      )}
    </>
  );
};

export default RootFooter;
